module.exports = __webpack_public_path__ + "img/finish.36a8dfb2.png";